/**
 * 所有页面都会引入的公共文件
 */

import '@/directives/index';
import '@/styles/icon/iconfont.css';
// toast css
import 'vue2-toast/lib/toast.css';
// 全局挂载logger
import './logger-inject';
import Sentry from '@/utils/sentry';
require('promise.prototype.finally').shim();
Sentry.initalize();
